import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import scenes from 'helpers/fovPreview/scenes'
import keys from 'ramda/src/keys'
import equals from 'ramda/src/equals'
import compose from 'ramda/src/compose'
import append from 'ramda/src/append'
import without from 'ramda/src/without'
import ifElse from 'ramda/src/ifElse'

class SceneSelector extends React.Component {
  sceneThumbnail = (name) => {
    const current = equals(this.props.currentScene, scenes[name])
    return (
      <div
        onClick={_ => this.props.updateScene(name)}
        className={current ? this.props.classes.sceneThumbnailCurrent : this.props.classes.sceneThumbnail}
        key={`thumbnail-${name}`}
      >
        { equals(name, 'Blank') ? <div className={this.props.classes.blank}><span>No Scene</span></div> : <img src={scenes[name]} /> }
      </div>
    )
  }

  appendBlank = compose(append('Blank'), without('Blank'))
  appendFisheye = compose(append('Blank'), append('360'), append('180'), without(['180', '360', 'Blank']))

  render() {
    const { props: { currentScene, currentCamera: { userUploadedSceneUrl, model }, setCustomScene, classes }, sceneThumbnail, appendBlank, appendFisheye } = this

    return (
      <div className={classes.container}>
        { userUploadedSceneUrl &&
          <div
            onClick={setCustomScene}
            className={userUploadedSceneUrl === currentScene ? classes.sceneThumbnailCurrent : classes.sceneThumbnail}
          >
            <img src={userUploadedSceneUrl} />
          </div>
        }
        { (ifElse(_ => model && model.is_fisheye, appendBlank, appendFisheye)(keys(scenes))).map(sceneThumbnail) }
      </div>
    )
  }
}

export default injectSheet(style)(SceneSelector)



// WEBPACK FOOTER //
// ./src/components/BottomBar/SimulatedView/SceneSelector/index.js